/* FELGER rev3-27-07 · Formulario de cotizacion (puntos 27 y 28).
 *
 * El cliente pidio: incluir RUT y Comuna, que TODOS los campos sean
 * obligatorios porque es una cotizacion, formato automatico para RUT y
 * telefono con ejemplo de llenado, y listas desplegables para Region y Comuna.
 *
 * La comuna depende de la region, asi que el select de comuna se rellena
 * cuando cambia el de region. Sin JS, el campo comuna queda como texto libre
 * (ver el liquid): mejor un dato escrito a mano que un formulario inservible.
 */
(function () {
  'use strict';

  /* 16 regiones de Chile con sus comunas, en orden norte-sur. */
  var REGIONES = {
    'Arica y Parinacota': ['Arica', 'Camarones', 'Putre', 'General Lagos'],
    'Tarapacá': ['Iquique', 'Alto Hospicio', 'Pozo Almonte', 'Camiña', 'Colchane', 'Huara', 'Pica'],
    'Antofagasta': ['Antofagasta', 'Mejillones', 'Sierra Gorda', 'Taltal', 'Calama', 'Ollagüe', 'San Pedro de Atacama', 'Tocopilla', 'María Elena'],
    'Atacama': ['Copiapó', 'Caldera', 'Tierra Amarilla', 'Chañaral', 'Diego de Almagro', 'Vallenar', 'Alto del Carmen', 'Freirina', 'Huasco'],
    'Coquimbo': ['La Serena', 'Coquimbo', 'Andacollo', 'La Higuera', 'Paihuano', 'Vicuña', 'Illapel', 'Canela', 'Los Vilos', 'Salamanca', 'Ovalle', 'Combarbalá', 'Monte Patria', 'Punitaqui', 'Río Hurtado'],
    'Valparaíso': ['Valparaíso', 'Casablanca', 'Concón', 'Juan Fernández', 'Puchuncaví', 'Quintero', 'Viña del Mar', 'Isla de Pascua', 'Los Andes', 'Calle Larga', 'Rinconada', 'San Esteban', 'La Ligua', 'Cabildo', 'Papudo', 'Petorca', 'Zapallar', 'Quillota', 'La Calera', 'Hijuelas', 'La Cruz', 'Nogales', 'San Antonio', 'Algarrobo', 'Cartagena', 'El Quisco', 'El Tabo', 'Santo Domingo', 'San Felipe', 'Catemu', 'Llaillay', 'Panquehue', 'Putaendo', 'Santa María', 'Quilpué', 'Limache', 'Olmué', 'Villa Alemana'],
    'Metropolitana de Santiago': ['Santiago', 'Cerrillos', 'Cerro Navia', 'Conchalí', 'El Bosque', 'Estación Central', 'Huechuraba', 'Independencia', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'Ñuñoa', 'Pedro Aguirre Cerda', 'Peñalolén', 'Providencia', 'Pudahuel', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Joaquín', 'San Miguel', 'San Ramón', 'Vitacura', 'Puente Alto', 'Pirque', 'San José de Maipo', 'Colina', 'Lampa', 'Tiltil', 'San Bernardo', 'Buin', 'Calera de Tango', 'Paine', 'Melipilla', 'Alhué', 'Curacaví', 'María Pinto', 'San Pedro', 'Talagante', 'El Monte', 'Isla de Maipo', 'Padre Hurtado', 'Peñaflor'],
    "Libertador General Bernardo O'Higgins": ['Rancagua', 'Codegua', 'Coinco', 'Coltauco', 'Doñihue', 'Graneros', 'Las Cabras', 'Machalí', 'Malloa', 'Mostazal', 'Olivar', 'Peumo', 'Pichidegua', 'Quinta de Tilcoco', 'Rengo', 'Requínoa', 'San Vicente', 'Pichilemu', 'La Estrella', 'Litueche', 'Marchihue', 'Navidad', 'Paredones', 'San Fernando', 'Chépica', 'Chimbarongo', 'Lolol', 'Nancagua', 'Palmilla', 'Peralillo', 'Placilla', 'Pumanque', 'Santa Cruz'],
    'Maule': ['Talca', 'Constitución', 'Curepto', 'Empedrado', 'Maule', 'Pelarco', 'Pencahue', 'Río Claro', 'San Clemente', 'San Rafael', 'Cauquenes', 'Chanco', 'Pelluhue', 'Curicó', 'Hualañé', 'Licantén', 'Molina', 'Rauco', 'Romeral', 'Sagrada Familia', 'Teno', 'Vichuquén', 'Linares', 'Colbún', 'Longaví', 'Parral', 'Retiro', 'San Javier', 'Villa Alegre', 'Yerbas Buenas'],
    'Ñuble': ['Chillán', 'Bulnes', 'Chillán Viejo', 'El Carmen', 'Pemuco', 'Pinto', 'Quillón', 'San Ignacio', 'Yungay', 'Quirihue', 'Cobquecura', 'Coelemu', 'Ninhue', 'Portezuelo', 'Ránquil', 'Treguaco', 'San Carlos', 'Coihueco', 'Ñiquén', 'San Fabián', 'San Nicolás'],
    'Biobío': ['Concepción', 'Coronel', 'Chiguayante', 'Florida', 'Hualqui', 'Lota', 'Penco', 'San Pedro de la Paz', 'Santa Juana', 'Talcahuano', 'Tomé', 'Hualpén', 'Lebu', 'Arauco', 'Cañete', 'Contulmo', 'Curanilahue', 'Los Álamos', 'Tirúa', 'Los Ángeles', 'Antuco', 'Cabrero', 'Laja', 'Mulchén', 'Nacimiento', 'Negrete', 'Quilaco', 'Quilleco', 'San Rosendo', 'Santa Bárbara', 'Tucapel', 'Yumbel', 'Alto Biobío'],
    'La Araucanía': ['Temuco', 'Carahue', 'Cunco', 'Curarrehue', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Saavedra', 'Teodoro Schmidt', 'Toltén', 'Vilcún', 'Villarrica', 'Cholchol', 'Angol', 'Collipulli', 'Curacautín', 'Ercilla', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Purén', 'Renaico', 'Traiguén', 'Victoria'],
    'Los Ríos': ['Valdivia', 'Corral', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'La Unión', 'Futrono', 'Lago Ranco', 'Río Bueno'],
    'Los Lagos': ['Puerto Montt', 'Calbuco', 'Cochamó', 'Fresia', 'Frutillar', 'Los Muermos', 'Llanquihue', 'Maullín', 'Puerto Varas', 'Castro', 'Ancud', 'Chonchi', 'Curaco de Vélez', 'Dalcahue', 'Puqueldón', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Osorno', 'Puerto Octay', 'Purranque', 'Puyehue', 'Río Negro', 'San Juan de la Costa', 'San Pablo', 'Chaitén', 'Futaleufú', 'Hualaihué', 'Palena'],
    'Aysén del General Carlos Ibáñez del Campo': ['Coyhaique', 'Lago Verde', 'Aysén', 'Cisnes', 'Guaitecas', 'Cochrane', "O'Higgins", 'Tortel', 'Chile Chico', 'Río Ibáñez'],
    'Magallanes y de la Antártica Chilena': ['Punta Arenas', 'Laguna Blanca', 'Río Verde', 'San Gregorio', 'Cabo de Hornos', 'Antártica', 'Porvenir', 'Primavera', 'Timaukel', 'Natales', 'Torres del Paine']
  };

  /* ---------- RUT ---------- */

  function limpiarRut(valor) {
    return String(valor || '').replace(/[^0-9kK]/g, '').toUpperCase();
  }

  /** "123456785" -> "12.345.678-5" */
  function formatearRut(valor) {
    var limpio = limpiarRut(valor);
    if (limpio.length < 2) return limpio;
    var cuerpo = limpio.slice(0, -1);
    var dv = limpio.slice(-1);
    return cuerpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + '-' + dv;
  }

  /** Verificador modulo 11. Un RUT mal tipeado no llega al correo de ventas. */
  function rutValido(valor) {
    var limpio = limpiarRut(valor);
    if (limpio.length < 7 || limpio.length > 9) return false;
    var cuerpo = limpio.slice(0, -1);
    var dv = limpio.slice(-1);
    if (!/^\d+$/.test(cuerpo)) return false;

    var suma = 0;
    var factor = 2;
    for (var i = cuerpo.length - 1; i >= 0; i--) {
      suma += Number(cuerpo.charAt(i)) * factor;
      factor = factor === 7 ? 2 : factor + 1;
    }
    var resto = 11 - (suma % 11);
    var esperado = resto === 11 ? '0' : resto === 10 ? 'K' : String(resto);
    return dv === esperado;
  }

  /* ---------- Telefono ---------- */

  /** Deja "+56 9 1234 5678" a partir de lo que sea que hayan tipeado. */
  function formatearTelefono(valor) {
    var d = String(valor || '').replace(/\D/g, '');
    if (d.indexOf('56') === 0) d = d.slice(2);
    d = d.slice(0, 9);
    if (d.length <= 1) return d ? '+56 ' + d : '';
    if (d.length <= 5) return '+56 ' + d.charAt(0) + ' ' + d.slice(1);
    return '+56 ' + d.charAt(0) + ' ' + d.slice(1, 5) + ' ' + d.slice(5);
  }

  function telefonoValido(valor) {
    var d = String(valor || '').replace(/\D/g, '');
    if (d.indexOf('56') === 0) d = d.slice(2);
    return d.length === 9;
  }

  /* ---------- Cableado ---------- */

  function marcarError(campo, mensaje) {
    campo.setCustomValidity(mensaje || '');
    var cont = campo.closest('.fg-field');
    if (cont) cont.classList.toggle('fg-field--error', Boolean(mensaje));
  }

  function poblarComunas(selRegion, selComuna) {
    var comunas = REGIONES[selRegion.value] || [];
    var previa = selComuna.value;
    selComuna.innerHTML = '';

    var vacia = document.createElement('option');
    vacia.value = '';
    vacia.textContent = comunas.length
      ? 'Selecciona tu comuna...'
      : 'Primero elige tu región';
    selComuna.appendChild(vacia);

    comunas.forEach(function (c) {
      var op = document.createElement('option');
      op.value = c;
      op.textContent = c;
      if (c === previa) op.selected = true;
      selComuna.appendChild(op);
    });
    selComuna.disabled = comunas.length === 0;
  }

  /* ---------- El codigo identifica: no volver a pedir lo que ya sabemos ----------
   *
   * Luca lo detecto probando: "puse el codigo y fui a la cotizacion y me pidio
   * los datos. No deberia pasar asi". Si el codigo es "practicamente una orden
   * de compra" (Felipe), volver a pedir RUT, razon social y telefono es el
   * error: FELGER ya los cargo al emitirlo.
   *
   * La vitrina NO puede resolverlo sola: aca solo viven los hashes de los
   * codigos, nunca la PII, y eso esta bien. Se le pregunta al backend, que es
   * donde vive el token de Admin.
   *
   * Si el backend responde que no puede resolver — porque todavia no tiene
   * SHOPIFY_ADMIN_TOKEN, o porque el codigo esta vencido — NO se esconde nada
   * y el formulario sigue pidiendo los datos como hasta ahora. Esconder campos
   * que despues nadie puede completar dejaria al cliente sin poder cotizar.
   */
  var IDENTIDAD = 'https://build-resend.vercel.app/api/identidad';

  function ocultarCampo(form, nombre) {
    var el = form.querySelector('[name="contact[' + nombre + ']"]');
    if (!el) return null;
    el.required = false;
    var caja = el.closest('.fg-field') || el.parentElement;
    if (caja) caja.hidden = true;
    return el;
  }

  /* Con codigo el flujo es una COMPRA (orden), no una cotizacion. El cliente
     lo pidio explicito: "con codigo... realizar una compra". Se cambia el copy
     del titulo, el boton, el lede y la nota. Idempotente. */
  function aplicarCopyCompra(form) {
    var titulo = document.querySelector('.fg-quote__title');
    if (titulo) titulo.textContent = 'Confirma tu compra';
    var lede = document.querySelector('.fg-quote__lede');
    if (lede) lede.textContent = 'Tu código de cliente ya te identifica. Revisa tus productos y confirma: FELGER prepara tu pedido con tu descuento aplicado y te envía el detalle para que lo aceptes.';
    var boton = form.querySelector('button[type="submit"]');
    if (boton) boton.innerHTML = 'Enviar compra <span aria-hidden="true">→</span>';
    var nota = form.querySelector('.fg-quote__note');
    if (nota) nota.textContent = 'Al confirmar, FELGER recibe tu pedido con tu descuento aplicado. No se procesan pagos en línea.';
  }

  function anunciarCliente(form, ficha) {
    var caja = document.createElement('div');
    caja.className = 'fg-quote__identidad';
    caja.innerHTML =
      '<p class="fg-quote__identidad-titulo">Comprando como <strong>' +
      String(ficha.razon_social || '').replace(/[<>&]/g, '') + '</strong></p>' +
      '<p class="fg-quote__identidad-detalle">RUT ' +
      String(ficha.rut || '').replace(/[<>&]/g, '') +
      ' · tus datos salen de tu ficha, no hace falta escribirlos de nuevo.' +
      '</p>' +
      '<button type="button" class="fg-quote__identidad-salir">No soy yo</button>';

    caja.querySelector('.fg-quote__identidad-salir').addEventListener('click', function () {
      /* Sale del codigo y recarga: el gate de precios tambien tiene que
         revertir, no alcanza con volver a mostrar los campos. */
      try { localStorage.removeItem('felger_fidelizado'); } catch (e) { /* sesion cerrada */ }
      window.location.reload();
    });

    form.insertBefore(caja, form.firstChild);
  }

  function precargarIdentidad(form) {
    var codigo = codigoClienteVigente();
    if (!codigo) return;

    /* El copy pasa a "compra" apenas hay codigo, aunque el backend de identidad
       tarde o falle: sigue siendo una compra. Ocultar campos, en cambio, espera
       a que identidad resuelva (mas abajo). */
    aplicarCopyCompra(form);

    fetch(IDENTIDAD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ codigo: codigo })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (ficha) {
        if (!ficha || !ficha.ok) return;
        /* 2026-08: compra con codigo = no se pide NINGUN dato. Se ocultan TODOS
           los campos; el backend (cotizacion.js) arma la orden con la ficha
           completa (nombre, email, RUT, empresa, telefono) y region/comuna se
           coordinan al confirmar el despacho. Si identidad no resolvio, se dejan
           los campos como fallback y el cliente completa a mano. */
        ['Nombre', 'RUT', 'Empresa', 'email', 'Telefono', 'Region', 'Comuna']
          .forEach(function (n) { ocultarCampo(form, n); });
        anunciarCliente(form, ficha);
      });
  }

  function iniciar() {
    var form = document.querySelector('[data-fg-cotizacion-form]');
    if (!form) return;

    precargarIdentidad(form);

    var selRegion = form.querySelector('[data-fg-region]');
    var selComuna = form.querySelector('[data-fg-comuna]');
    var inpRut = form.querySelector('[data-fg-rut]');
    var inpTel = form.querySelector('[data-fg-telefono]');

    if (selRegion && selComuna) {
      /* El select de comuna arranca deshabilitado; sin region no hay comuna. */
      poblarComunas(selRegion, selComuna);
      selRegion.addEventListener('change', function () {
        selComuna.value = '';
        poblarComunas(selRegion, selComuna);
      });
    }

    if (inpRut) {
      inpRut.addEventListener('input', function () {
        marcarError(inpRut, '');
      });
      inpRut.addEventListener('blur', function () {
        if (!inpRut.value.trim()) return;
        inpRut.value = formatearRut(inpRut.value);
        marcarError(inpRut, rutValido(inpRut.value) ? '' : 'Revisa el RUT: el dígito verificador no calza.');
      });
    }

    if (inpTel) {
      inpTel.addEventListener('input', function () {
        var pos = inpTel.value.length;
        inpTel.value = formatearTelefono(inpTel.value);
        /* Al reformatear se pierde el cursor; se manda al final, que es donde
           esta escribiendo la persona en el 99% de los casos. */
        if (pos >= inpTel.value.length) {
          inpTel.setSelectionRange(inpTel.value.length, inpTel.value.length);
        }
        marcarError(inpTel, '');
      });
      inpTel.addEventListener('blur', function () {
        if (!inpTel.value.trim()) return;
        marcarError(inpTel, telefonoValido(inpTel.value) ? '' : 'El teléfono debe tener 9 dígitos.');
      });
    }

    form.addEventListener('submit', function (e) {
      var problemas = [];
      /* Solo se validan si el campo sigue activo. Con codigo, RUT y telefono se
         ocultan y se marcan `required=false`: validarlos igual bloquearia el
         submit de un cliente que no debe escribir nada. */
      if (inpRut && inpRut.required && !rutValido(inpRut.value)) {
        marcarError(inpRut, 'Revisa el RUT: el dígito verificador no calza.');
        problemas.push(inpRut);
      }
      if (inpTel && inpTel.required && !telefonoValido(inpTel.value)) {
        marcarError(inpTel, 'El teléfono debe tener 9 dígitos.');
        problemas.push(inpTel);
      }
      if (problemas.length) {
        e.preventDefault();
        problemas[0].focus();
        return;
      }
      if (!form.checkValidity()) return; // que el navegador muestre lo suyo
      enviarPorResend(e, form);
    });
  }

  /* ---------- Envio por Resend (puntos 31, 33, 34 y 35) ----------
   *
   * El formulario nativo de Shopify manda un correo de TEXTO PLANO desde
   * mailer@shopify.com: es el "llegan los correos sin diseno" que reporto el
   * cliente. La pagina de Contacto ya se habia migrado a Resend; la cotizacion
   * habia quedado atras.
   *
   * Se reutiliza el MISMO endpoint que Contacto, que ya esta probado y manda
   * dos correos: uno branded a FELGER con Responder al cliente, y una
   * confirmacion al cliente. Contrato: {nombre,email,telefono,comuna,region,
   * mensaje} -> {ok:true}.
   *
   * El detalle que el endpoint no conoce (RUT, empresa, productos y descuento)
   * viaja dentro de `mensaje`, que es lo que el correo imprime.
   *
   * Si el JS falla, no se intercepta el submit y el form nativo sigue andando:
   * un correo feo es mejor que ninguna cotizacion.
   */

  /* Endpoint propio de cotizaciones. Antes se reusaba /api/contact y por eso el
     asunto decia "mensaje" en vez de "cotizacion"; ahora hay uno dedicado, con
     campos propios (rut, empresa, productos) y el copy correcto. */
  var ENDPOINT = 'https://build-resend.vercel.app/api/cotizacion';

  /* FELGER rev3-27-07 · hallazgo CRITICO de la auditoria.
   *
   * Antes esta funcion leia `descuento_pct` de localStorage y el porcentaje
   * viajaba en el correo. Cualquiera podia abrir la consola, escribir
   * `descuento_pct: 50` y mandarle a FELGER una cotizacion con un descuento
   * inventado, que un vendedor podia honrar de buena fe.
   *
   * Ahora se manda el CODIGO, no el porcentaje. El descuento real lo resuelve
   * FELGER contra la ficha del cliente. El navegador dejo de ser la fuente de
   * verdad de un dato con consecuencia comercial.
   */
  function codigoClienteVigente() {
    try {
      var raw = localStorage.getItem('felger_fidelizado');
      if (!raw) return '';
      var obj = JSON.parse(raw);
      return (obj && typeof obj.codigo === 'string') ? obj.codigo.trim().slice(0, 40) : '';
    } catch (e) { return ''; }
  }

  function clp(centavos) {
    return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
  }

  /* Detalle de productos + totales, en texto plano. El endpoint lo imprime tal
     cual dentro de un <pre>, asi que el alineado importa. */
  function armarProductos(carro) {
    if (!carro || !carro.items || !carro.items.length) return '';
    var partes = ['PRODUCTOS (' + carro.item_count + '):'];
    carro.items.forEach(function (it) {
      partes.push(
        '- ' + it.quantity + 'x ' + it.product_title +
        (it.variant_title && it.variant_title !== 'Unica' ? ' / ' + it.variant_title : '') +
        (it.sku ? ' — SKU ' + it.sku : '')
      );
    });

    var codigo = codigoClienteVigente();
    partes.push('', 'Total de lista: ' + clp(carro.total_price) + ' + IVA (precio neto)');
    if (codigo) {
      /* Punto 35: el cliente reclamo que la cotizacion no mostraba su
         descuento. Se identifica al cliente por su codigo; el porcentaje y el
         total final los pone FELGER desde la ficha, no el navegador. */
      partes.push(
        'Cliente con código: ' + codigo,
        'Aplicar el descuento de su ficha sobre el total de lista.'
      );
    } else {
      partes.push('Sin código de cliente: cotizar con lista general.');
    }
    return partes.join('\n');
  }

  /* Contrato operativo para Shopify: el texto anterior sigue viajando porque
     es legible en los correos, pero el pedido usa IDs de variante reales para
     que Shopify calcule precio, IVA e inventario. Los precios viajan sólo para
     el fallback de compatibilidad; el backend no los usa si hay variant_id. */
  function armarItems(carro) {
    if (!carro || !Array.isArray(carro.items)) return [];
    return carro.items.map(function (it) {
      var variante = it.variant_title;
      if (variante === 'Default Title' || variante === 'Único' || variante === 'Unica') variante = '';
      var imagen = it.image || (it.featured_image && it.featured_image.url) || '';
      return {
        variant_id: Number(it.variant_id),
        quantity: Number(it.quantity),
        price: Number(it.price),
        title: String(it.product_title || it.title || '').slice(0, 255),
        sku: String(it.sku || '').slice(0, 64),
        variante: String(variante || '').slice(0, 120),
        image: String(imagen || '').slice(0, 500),
        tipo: String(it.product_type || it.type || '').slice(0, 120)
      };
    });
  }

  function nuevoRequestId() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
      throw new Error('Tu navegador no puede generar una referencia segura.');
    }
    var bytes = new Uint8Array(16);
    crypto.getRandomValues(bytes);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (b) {
      return b.toString(16).padStart(2, '0');
    }).join('');
    return [
      hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16),
      hex.slice(16, 20), hex.slice(20),
    ].join('-');
  }

  function enviarPorResend(evento, form) {
    evento.preventDefault();
    var requestId;
    try {
      requestId = nuevoRequestId();
    } catch (e) {
      mostrarError(form, e && e.message);
      return;
    }

    var boton = form.querySelector('button[type="submit"]');
    var textoOriginal = boton ? boton.innerHTML : '';
    if (boton) { boton.disabled = true; boton.textContent = 'Enviando…'; }

    var leer = function (n) {
      var el = form.querySelector('[name="contact[' + n + ']"]');
      return el ? el.value.trim() : '';
    };

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (carro) {
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            nombre: leer('Nombre'),
            email: leer('email'),
            telefono: leer('Telefono'),
            rut: leer('RUT'),
            empresa: leer('Empresa'),
            comuna: leer('Comuna'),
            region: leer('Region'),
            mensaje: leer('body'),
            codigo: codigoClienteVigente(),
            request_id: requestId,
            items: armarItems(carro),
            productos: armarProductos(carro),
            website: '' // honeypot: vacio desde el sitio, lleno desde un bot
          })
        });
      })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok && j && j.ok, error: j && j.error }; });
      })
      .then(function (res) {
        if (!res.ok) throw new Error(res.error || 'envío rechazado');
        mostrarExito(form);
      })
      .catch(function (err) {
        if (boton) { boton.disabled = false; boton.innerHTML = textoOriginal; }
        mostrarError(form, err && err.message);
      });
  }

  function mostrarExito(form) {
    var boton = form.querySelector('button[type="submit"]');
    if (boton) {
      boton.disabled = true;
      boton.textContent = 'Solicitud enviada';
      boton.setAttribute('aria-disabled', 'true');
    }
    var caja = document.createElement('div');
    caja.className = 'fg-quote__ok';
    caja.setAttribute('role', 'status');
    caja.innerHTML = codigoClienteVigente()
      ? '<strong>¡Recibimos tu compra!</strong>' +
        '<p>Preparamos tu pedido con tu descuento aplicado y te enviamos el detalle a tu correo para que lo aceptes.</p>'
      : '<strong>¡Recibimos tu cotización!</strong>' +
        '<p>Te llega una copia a tu correo. Respondemos en 24 horas hábiles.</p>';
    form.parentNode.insertBefore(caja, form);
    form.hidden = true;
    caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function mostrarError(form, detalle) {
    var previo = form.querySelector('.fg-quote__err--js');
    if (previo) previo.remove();
    var caja = document.createElement('div');
    caja.className = 'fg-quote__err fg-quote__err--js';
    caja.setAttribute('role', 'alert');
    caja.innerHTML =
      '<strong>No pudimos enviar tu ' + (codigoClienteVigente() ? 'compra' : 'cotización') + '.</strong>' +
      '<p>Escríbenos directo a <a href="mailto:ventas@felger.cl">ventas@felger.cl</a> ' +
      'o por WhatsApp al +56 9 3586 1203.' +
      (detalle ? ' <span class="fg-quote__err-det">(' + detalle + ')</span>' : '') +
      '</p>';
    form.insertBefore(caja, form.firstChild);
    caja.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
